import { createElement as rc } from 'react';
import * as reactMenu from '@szhsin/react-menu';
import PropTypes from 'prop-types';
import styled from '../../styled';
import fromTheme from '../../fromTheme';

const MenuHeader = styled(reactMenu.MenuHeader).withConfig({
    shouldForwardProp: prop => !['textWeight', 'textSize'].includes(prop)
})`
    text-transform: none;
    padding: 0;
    font-size: ${fromTheme('fontSizeLarge')};
    font-family: ${fromTheme('fontAlternate')};
    color: ${fromTheme('menu', 'color')};
    ${({ theme, textWeight, textSize }) => fromTheme('fonts', textSize, textWeight)({ theme })}
`;

export default props => {
    const { title, textWeight, textSize, hNode: { title: ObsoleteTitle } = {} } = props || {};
    const displayTitle = title || ObsoleteTitle || '';

    return rc(MenuHeader, { textWeight, textSize, 'aria-label': displayTitle }, displayTitle);
};

MenuHeader.propTypes = {
    title: PropTypes.string, // whatever you want to display as the header text
    textWeight: PropTypes.oneOf(['regular', 'medium', 'semiBold', 'bold']).isRequired, // this is the hex color itself (e.g. #ff0000), not something like 'warning'
    textSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
    // Obsolete, prefer passing in title directly
    hNode: PropTypes.shape({
        title: PropTypes.string
    })
};

MenuHeader.defaultProps = {
    textSize: 'md',
    textWeight: 'semiBold'
};
